import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import './styles.scss';

import services from '../../services'

import FormLogin from './FormLogin'
import FormCompletarCadastroAuto from './FormCompletarCadastroAuto';
import FormConclusaoPreCadastro from './FormConclusaoPreCadastro';
import FormRecuperarSenha from './FormRecuperarSenha';
import ConclusaoRecuperarSenha from './ConclusaoRecuperarSenha';

import footerCompany from '../../assets/img/footer.png'

const formExisteParceiroInitialState = {
  documento: '',
  codigo: '',
  idParceiro: '',
}

const modalInitialStatus = {
  esqueciSenha: false,
  primeiroAcesso: false,
  conclusaoPreCadastro: false,
  conclusaoEsqueciSenha: false
}


const Login = props => {
  const history = useHistory();
  
  const [formParceiro, setFormParceiro] = React.useState({...formExisteParceiroInitialState});
  const [modalStatus, setModalStatus] = useState(modalInitialStatus);
  


  useEffect(() => {
    async function init() {
      let isAuthenticated = services.storage.get('isAuthenticated')
      let isUserCompany = services.storage.get('isUserCompany')
      if (isAuthenticated && !isUserCompany) {
        //history.push(`/minhas-vagas`)
        history.push(`/home`)
      }
      if (isAuthenticated && isUserCompany) {
        history.push(`/home`)
      }
    }
    init()
  }, [])
  
  return (
    <div>
      <div className='container-fluid loginPage'>
        <div className='row'>
          <div className='col-md-6 offset-md-6 boxLogin'>
            <FormLogin
              modalSenha={ () => { setModalStatus({...modalStatus, esqueciSenha: true}) }}
              modalPrimeiroAcesso={ () => { setModalStatus({...modalStatus, primeiroAcesso: true}) }}
            />
          </div>
        </div>

        
        <FormConclusaoPreCadastro 
          modalStatus={modalStatus}
          setModalStatus={setModalStatus}
        />

        <FormCompletarCadastroAuto 
          formParceiro={formParceiro}
          modalStatus={modalStatus}
          setModalStatus={setModalStatus}
        />

        <FormRecuperarSenha 
          modalStatus={modalStatus}
          setModalStatus={setModalStatus}
        />

        <ConclusaoRecuperarSenha 
          modalStatus={modalStatus}
          setModalStatus={setModalStatus}
        />
    
      </div>
      
      <div className="container-fluid footerPage"> 
        <div className="row footerPage">
            <div className="col-md-12 footerPage">  
              <div> 
                  <img src={footerCompany} alt=" " />
              </div>
            </div>
        </div>
      </div>
    </div>
  );
  
}

export default Login;
